import React from 'react';
import { useFormikContext } from 'formik';

import PaymentMethods from '../PaymentMethods';

function FormPaymentMethods({ name, status, ...rest }) {
  const { setFieldTouched, setFieldValue, values, errors } = useFormikContext();
  const value = values[name];
  const error = errors[name];
  const _onMethodChange = (value) => {
    setFieldTouched(name);
    setFieldValue(name, { method: value });
  };
  const _onInputChange = (inputName) => (inputValue) => {
    setFieldTouched(inputName);
    setFieldValue(`${name}.${inputName}`, inputValue);
  };
  return (
    <PaymentMethods
      status={status}
      error={error?.method || rest.error}
      errorCardNumber={error?.cardNumber}
      errorExpiration={error?.cardMonth || error?.cardYear}
      errorCvv={error?.cardCvv}
      value={value}
      onInputChange={_onInputChange}
      onMethodChange={_onMethodChange}
    />
  );
}

export default FormPaymentMethods;
